<template>
    <transition name="modal">
        <div v-if="open && user" class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">

                    <div class="modalheader">
                        <h3>
                            <div class="m-2 text-center">
                            Hej {{user.Name}}, välkommen till Analyscenter!
                            </div>
                        </h3>
                    </div>

                    <div class="modalbody">
                        <div class="m-2">
                        Efter fem år med Bokslutsanalys hos Grant Thornton är vi stolta över att presentera den nyutvecklade plattformen Analyscenter och tycker det är kul att du är nyfiken på vår nya produkt. 
                        </div>
                        <h4 class="m-2 pt-2">
                        Analys- och presentationsverktyg för proffsanvändare
                        </h4>
                        <div class="m-2">
                        Analyscenter är en i grunden helt nyutvecklad plattform där vi utgått från en proffsanvändare som arbetar med rådgivning kring redovisning och revision. Vi vill förenkla din vardag genom att skapa enkla flöden för att analysera, visualisera och presentera ekonomisk information baserad antingen på historisk offentlig information eller via importerade SIE-filer.
                        </div>

                        <h4 class="m-2 pt-2">
                        Kontinuerlig utveckling
                        </h4>
                        <div class="m-2">
                        Plattformen utvecklas kontinuerligt och särskilt som tidig användare kommer du att märka att det tillkommer funktionalitet regelbundet. Om du vill vara med och påverka utvecklingen och innehållet i Analyscenter får du gärna maila dina idéer till <a href="mailto:monika.lindberg@se.gt.com">monika.lindberg@se.gt.com</a> och/eller <a href="mailto:kristoffer.noren@bolagskompassen.se">kristoffer.noren@bolagskompassen.se</a>.
                        </div>

                        <h4 class="m-2 pt-2">
                        Detta vet vi om dig
                        </h4>
                        <div class="m-2">
                        För att kunna hjälpa till med supportärenden, ta fram statistik & faktureringsunderlag och framförallt kunna skapa en så smidig användarupplevelse som möjligt för dig och dina kollegor så tar Analyscenter del av följande personinformation om dig:
                        <ul class="pt-2">
                            <li>
                                Namn: {{user.Name}}
                            </li>
                            <li>
                                E-post: {{user.Email}}
                            </li>
                            <li>
                                Kostnadsställe: {{user.Locality}}
                            </li>
                        </ul>
                        </div>
                    </div>

                    <div style="text-align: center;">
                        <button class="btn btn-primary btn-lg w-50" @click="open = false">
                            Stäng
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    /* tslint:disable */
    import user from '@/store/modules/user';
    export default {
        name: 'ErrorModal',
        data: function() {
            return {
                open: true,
            }
        },
        computed: {
            user() {
                return user.user;
            },
        }
    };
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 1024px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
    }

    .modalheader {
        margin: 0;
    }

    .modalbody {
        margin: 20px 0;
        padding: 10px;
    }

    .modalfooter {
        margin: 20px 0;
        padding: 10px;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
